import { FeedLetConfig } from './types'
import { FeedLetWidget } from './widget'

// Global FeedLet object
declare global {
  interface Window {
    FeedLet: {
      init: (config: FeedLetConfig) => FeedLetWidget
      getInstance: () => FeedLetWidget | null
      destroy: () => void
      FeedLetWidget: typeof FeedLetWidget
    }
  }
}

class FeedLet {
  private static instance: FeedLetWidget | null = null

  static init(config: FeedLetConfig): FeedLetWidget {
    if (this.instance) {
      this.instance.destroy()
    }

    this.instance = new FeedLetWidget(config)
    this.instance.init()
    return this.instance
  }

  static getInstance(): FeedLetWidget | null {
    return this.instance
  }

  static destroy(): void {
    if (this.instance) {
      this.instance.destroy()
      this.instance = null
    }
  }
}

// Expose to global scope
if (typeof window !== 'undefined') {
  window.FeedLet = {
    init: (config: FeedLetConfig) => FeedLet.init(config),
    getInstance: () => FeedLet.getInstance(),
    destroy: () => FeedLet.destroy(),
    FeedLetWidget: FeedLetWidget // Add the class to the global object
  }
}

// For ES modules
export default FeedLet
export { FeedLetWidget }
export * from './types' 